import { CallServiceSummaryFieldFoundResponse } from 'src/api/types';

export type Field = CallServiceSummaryFieldFoundResponse & {
    fieldName: string;
};

export const Enable = {
    CLOSE: 0,
    OPEN: 1,
};
